import axios from 'axios';

//to change port in two locations 1db.js 2services.js

// for local host
//const API_BASE_URL = 'http://127.0.0.1:9002/cal-onINFANT/';

// for Global host

// for calon local server
const API_BASE_URL = 'http://infant.calonev.com:9002/cal-onINFANT/';




const API_BASE_URL_ERP = 'http://erp.cal-on.com:4000/cal-onERPDB/';


class Services {
  
  /*  
  getHospitalsdataByHospitalwise(data) { return axios.post(API_BASE_URL + 'get-hospitaldata-byhospitalwise.php', data); }
  deleteHospitalsdata(data) { return axios.post(API_BASE_URL + 'delete-hospitaldata.php', data); }
 
  getMotherTagsdataByHospitalwise(data) { return axios.post(API_BASE_URL + 'get-hospital-mothertags-data.php', data); }
  deleteMotherTagsdataByHospitalwise(data) { return axios.post(API_BASE_URL + 'delete-hospital-mothertags-data.php', data); }
  
  getMastersdataByHospitalwise(data) { return axios.post(API_BASE_URL + 'get-hospital-masters-data.php', data); }
  deleteMastersdataByHospitalwise(data) { return axios.post(API_BASE_URL + 'delete-hospital-masters-data.php', data); }
  
  getChildTagsdataByHospitalwise(data) { return axios.post(API_BASE_URL + 'get-hospital-childtags-data.php', data); }
  deleteChildTagsdataByHospitalwise(data) { return axios.post(API_BASE_URL + 'delete-hospital-childtags-data.php', data); }
  */
  
  getHospitalslistdata(data) { return axios.post(API_BASE_URL + 'hospitaldata_t/get_hospitaldatalist', data); }
  getHospitalsdataByHospitalwise(data) { return axios.post(API_BASE_URL + 'hospitaldata_t/get_hospitaldata_report', data); }
  deleteHospitalsdata(data) { return axios.post(API_BASE_URL + 'hospitaldata_t/delete_hospitaldata', data); }
 
  getMastersdataByHospitalwise(data) { return axios.post(API_BASE_URL + 'mastersdata_t/get_mastersdata_report', data); }
  deleteMastersdataByHospitalwise(data) { return axios.post(API_BASE_URL + 'mastersdata_t/delete_mastersdata', data); }
  
  getMotherTagsdataByHospitalwise(data) { return axios.post(API_BASE_URL + 'mothertagsdata_t/get_mothertagdata_report', data); }
  deleteMotherTagsdataByHospitalwise(data) { return axios.post(API_BASE_URL + 'mothertagsdata_t/delete_mothertagdata', data); }
  
  getChildTagsdataByHospitalwise(data) { return axios.post(API_BASE_URL + 'childtagsdata_t/get_childtagsdata_report', data); }
  deleteChildTagsdataByHospitalwise(data) { return axios.post(API_BASE_URL + 'childtagsdata_t/delete_childtagsdata', data); }

  getPatientlistdata(data) { return axios.post(API_BASE_URL + 'patientsdata_t/get_patientlist', data); }
  getPatientsdataByHospitalwise(data) { return axios.post(API_BASE_URL + 'patientsdata_t/get_patientdata_report', data); }
  deletePatientsdataByHospitalwise(data) { return axios.post(API_BASE_URL + 'patientsdata_t/delete_patientdata', data); }

  getStafflistdata(data) { return axios.post(API_BASE_URL + 'staff_t/get_stafflist_report', data); }
  getEmpEntryPatientsdata(htype,hcode,uniquenum,fromdate,todate) { return axios.get(API_BASE_URL + 'patientsdata_t/get_emp_entry_patientlist/' + htype + "/"+ hcode + "/"+ uniquenum + "/"+ fromdate + "/"+ todate); }

  empGetuniquenumber(phno,aadhar) { return axios.get(API_BASE_URL_ERP + 'employee_t/infant_emp_uniquenumber/' + phno + "/"+ aadhar); }
  empGetAttendanceWorkupdate(data) { return axios.post(API_BASE_URL_ERP + 'api_app/empindividualDtls', data); }
  
}

export default new Services()